import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import {PreferenceStructurePhraseItem} from "./PreferenceStructurePhraseItem";
import {preferenceSaveService} from "../../services/preferenceSaveService";

const PreferenceStructurePhrase = ({ preferenceId }) => {
    const { i18n } = useTranslation();
    const [phrases, setPhrases] = useState([]);

    useEffect(() => {
        preferenceSaveService.loadPhrases(() => {
            const currentPhrases = preferenceSaveService.getPhrases().map(it => {
                return {
                    id: it.id,
                    componentId: uuid(),
                    content: it.content,
                    locale: it.locale,
                }
            });
            const currentComponentKey = uuid();
            currentPhrases.push({
                id: null,
                componentId: currentComponentKey,
                content: "",
                locale: i18n.resolvedLanguage,
            });
            setPhrases(currentPhrases);
        });
    }, [preferenceId]);

    const handleAddPhrase = (phraseContent, phraseId) => {
        const currentPhrases = [...phrases];
        currentPhrases.forEach((it) => {
            if (!it.id) {
                it.id = phraseId;
                it.content = phraseContent;
            }
        });
        const currentComponentKey = uuid();
        currentPhrases.push({
            id: null,
            componentId: currentComponentKey,
            content: "",
            locale: i18n.resolvedLanguage,
        });
        setPhrases(currentPhrases);
    }

    const handleDeletePhrase = (index) => {
        preferenceSaveService.deletePhrase(index);
        setPhrases(phrases.filter(it => it.id !== index));
    }

    return (
        <label className="block__text preference__form-label">
            <span>{i18n.t(`app.page.preference.addTitles.phrase`)}</span>
            {phrases.map(phrase  => (
                <PreferenceStructurePhraseItem
                    phrase={phrase}
                    handleDeletePhrase={handleDeletePhrase}
                    handleAddPhrase={handleAddPhrase}
                    key={phrase.componentId} />
            ))}
        </label>
    );
};

export default PreferenceStructurePhrase;
